 import React, {useState, useEffect, useRef} from 'react';
// Layout
import TakisNav from './TakisNav';
import TakisFooter from "./TakisFooter";
import SkipNavLink from "./SkipNavLink";
// Hooks
import useGlobalData from '../hooks/useGlobalData';
import { useLayoutStyles } from './TakisLayout.styles'
// Pages
import Home from '../pages/Home';
import Article from '../pages/Article';
import ProductDetail from '../pages/ProductDetail';
import Recipes from '../pages/Recipes';
import Misc from '../pages/Misc';
import Category from '../pages/Category';
import Products from '../pages/Products';
import Components from '../pages/Components';
import Search from '../pages/Search';

// Lib
import {Switch, Route} from "react-router-dom";
import Promotions from '../pages/Promotions';

const Layout = () => {
  const isFirstRender = useRef(true);
  const [globData, setGlobData] = useState('');
  const [pages, setPages] = useState([]);
  const { isLoading, globalData } = useGlobalData();
  const contentId = "main-content"
  const classes = useLayoutStyles();
  const [menuOffset, setMenuOffset] = useState(0)

  useEffect(() => {
    if (globalData) {
      setGlobData(globalData);
      setPages(globalData?.header?.nav_options);
    }
  }, [globalData]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    document.activeElement.blur()
  });

  if (isLoading || !globData) {
    return (<></>);
  }

  const getComponent = (page) => {
    switch (page.type){
      case 'category':
        return <Category pagePath={page.link}/>
      case 'product':
        return <ProductDetail pagePath={page.link}/>
      case 'recipe':
      case 'promotion':
        return <Article pagePath={page.link}/>
      case 'misc':
        return <Misc pagePath={page.link}/>
      case 'products':
        return <Products pagePath={page.link}/>
      case 'recipes':
        return <Recipes pagePath={page.link} pageType={page.type}/>
      case 'promotions':
        return <Promotions pagePath={page.link} pageType={page.type}/>
      default :
        return;
    }
  }

  const pageFilter = (pages) => {
    const filtered = pages.filter(function(page) {
      if (page.link === "/"){
        return false;
      }
      return true;
    }, []);
    return filtered;
  }

  const subPageFilter = (pages) => {
    const filtered = pages.filter(function(page) {
      if (page.sub_nav_options.length !== 0 && page.sub_nav_options[0].link !== "/"){
        return true;
      }
      return false;
    }, []);
    return filtered;
  }

  return (
    <>
      <SkipNavLink id={contentId}/>
      <TakisNav data={globData.header} setMenuHeight={(height) => {
        setMenuOffset(height);
      }}/>
      <main
        className={classes.content}
        id={contentId}
        tabindex="-1"
        style={{
          marginTop: `${menuOffset}px`
        }}
        >
        <Switch>
          {pageFilter(pages).map(page => {
            return (
              <Route exact path={page.link} key={`route${page.id}`}>
                {getComponent(page)}
              </Route>
            )
          })}
          {subPageFilter(pages).map(page => {
            return page.sub_nav_options.map(sub_option => {
              return (
                <Route exact path={sub_option.link} key={`route${sub_option.id}`}>
                  {getComponent(sub_option)}
                </Route>
              )
            })
          })}
          <Route exact path="/components">
            <Components />
          </Route>
          <Route
            exact
            path={`${globalData.header.search_field.url}`}
            >
            <Search
              searchConfig={{
                ...globalData.header.search_field
              }}
            />
          </Route>
          <Route exact path="/es">
            <Home />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="*">
            <Misc pagePath="/404"/>
          </Route>
        </Switch>
      </main>
      <TakisFooter data={globData.footer}></TakisFooter>
    </>
  );
};

export default Layout;
